import {Icon} from '@wandb/weave/components/Icon';
import React from 'react';
import TimeAgo from 'react-timeago';
// eslint-disable-next-line wandb/no-deprecated-imports
import {Table} from 'semantic-ui-react';

import {AgentData} from '../state/graphql/sweepPageQuery';

type AgentTableProps = {
  agents: AgentData[];
};

const AgentTable = React.memo(({agents}: AgentTableProps) => {
  return (
    <div className="action-table report-table">
      <Table selectable padded>
        <Table.Header>
          <Table.Row>
            <Table.HeaderCell>Agent</Table.HeaderCell>
            <Table.HeaderCell>Host</Table.HeaderCell>
            <Table.HeaderCell singleLine>Last heartbeat</Table.HeaderCell>
            <Table.HeaderCell singleLine>Runs launched</Table.HeaderCell>
          </Table.Row>
        </Table.Header>
        <Table.Body>
          {agents.map(agent => {
            return (
              <Table.Row className="action-table__row" key={agent.id}>
                <Table.Cell className="action-table__row__desription-cell">
                  <div style={{display: 'flex', alignItems: 'flex-start'}}>
                    <Icon style={{marginRight: 12}} name="sweeps-broom-alt" />
                    {agent.name}
                  </div>
                </Table.Cell>
                <Table.Cell singleLine>{agent.host}</Table.Cell>
                <Table.Cell singleLine>
                  <TimeAgo date={agent.heartbeatAt} live={false} />
                </Table.Cell>
                <Table.Cell singleLine>{agent.totalRuns}</Table.Cell>
              </Table.Row>
            );
          })}
        </Table.Body>
      </Table>
    </div>
  );
});
AgentTable.displayName = 'AgentTable';

export default AgentTable;
